import Client from './KomodoClient';
import { pagerRows } from './Resource';

// komodo warehouse locations (货位): position_attr_mapping (which location sets a warehouse uses,
// max 5) + position_cell (the generated cells) + stock check before deleting a cell.
const enc = encodeURIComponent;
export const MAX_MAPPING_COUNT = 5;

const mappings = (wareHouseCode) =>
	Client.get(`/api/position_attr_mapping/${enc(wareHouseCode)}`).then(
		pagerRows
	);
// Remove-all-then-add; an empty list disables the warehouse's PositionEnabled flag server-side.
const saveMappings = (wareHouseCode, list) =>
	Client.put(`/api/position_attr_mapping/${enc(wareHouseCode)}`, {
		recordList: list || [],
	});

const cells = (wareHouseCode) =>
	Client.get(`/api/position_cell/parent-list/${enc(wareHouseCode)}`);
const saveCells = (wareHouseCode, list) =>
	Client.put(`/api/position_cell/${enc(wareHouseCode)}`, {
		recordList: list || [],
	});
const deleteCell = (wareHouseCode, cellCode) =>
	Client.del(`/api/position_cell/${enc(wareHouseCode)}/${enc(cellCode)}`);
// Stock rows on a cell (must be empty before the cell can be deleted).
const stockOf = (deptCode, wareHouseCode, cellCode) =>
	Client.post('/api/nowpositionquantity/query-list', {
		deptCode,
		wareHouseCode,
		cellCode,
	});
// Location sets of a company that have values (PositionAttributeController dept/{deptCode}).
const locationSets = (deptCode) =>
	Client.get(`/api/position_attribute/dept/${enc(deptCode)}`);

export default {
	MAX_MAPPING_COUNT,
	mappings,
	saveMappings,
	cells,
	saveCells,
	deleteCell,
	stockOf,
	locationSets,
};
